import type { FC } from 'react'
import { ClockInOutDetailsBase } from 'screens/Rostering/components/ClockInOutDetailBase'
import type { ClockInOutAction } from 'screens/Rostering/hooks/useClockInOut'
import type {
  ClockInLocation,
  GeolocationStatus
} from 'screens/Rostering/types'

type ClockInDetailsProps = {
  time?: string
  note?: string
  location?: ClockInLocation
  openClockInOutModal: () => void
  warnings?: string[]
  action: ClockInOutAction
  isDraft?: boolean
  isDeletedSU?: boolean
  timezone?: string
  publishedRota?: boolean
  showInvalidAddressForGeofencingWarning?: boolean
  clockInGeolocationStatus?: GeolocationStatus
}

export const ClockInDetails: FC<ClockInDetailsProps> = (props) => (
  <ClockInOutDetailsBase
    {...props}
    type="in"
    geolocationStatus={props.clockInGeolocationStatus}
  />
)
